const getVisibilityState = () => document.visibilityState || 'unknown';

export default {
  getVisibilityState,
};
